<!-- FREEFORM COMPONENT - is not connected to control, we get result by emmiting value outside -->

<div class="check-box-freeform-functional">
  @if (helpText) {
    <app-help-text [dataContext]="helpText" [checkbox]="true"></app-help-text>
  }
  <mat-checkbox
    #checkboxElement
    [checked]="initialValue"
    [class.mr-4]="helpText"
    [disabled]="isReadonly"
    (change)="onCheckboxChange($event, checkboxElement)"
    >
    {{ caption | translate }}
  </mat-checkbox>
</div>
